import axios from 'axios';
import {
    baseUrl
} from "@/config/env";
import {
    getToken
} from "@/util/auth";
import store from "@/store";
import {
    parseParam
} from "@/util/util";


// function excelaxios(url, params) {

// }
// export default excelaxios
export const excelaxios = (url, params) => {
    var excelName = params.excelName;
    params = parseParam(params);
    url = `${baseUrl}` + url + params
    function download(data) {
        if (!data) {
            return;
        }
        var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        });
        var url = window.URL.createObjectURL(blob);
        var aLink = document.createElement("a");
        console.log(aLink)
        aLink.style.display = "none";
        aLink.href = url;
        aLink.setAttribute("download", excelName ? excelName : 'excel.csv');
        document.body.appendChild(aLink);
        aLink.click();
        document.body.removeChild(aLink); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
    }
    axios.get(url, {
            headers: {
                ACCEPT_TOKEN: store.getters.token ? getToken() : ""
            },
            responseType: "blob" //二进制流
        })
        .then((res) => {
            download(res);
            console.log(res);
        })
        .catch(function (error) {
            console.log(error);
        });

}